<script setup lang="ts">
/**
 * PlatformIcon — 浏览器平台 logo 包装
 * - chrome / edge / firefox 用 webp
 */
import { computed } from 'vue'
import type { BrowserPlatform } from '@/config/brand'

const props = withDefaults(
  defineProps<{
    platform: BrowserPlatform
    size?: number
    fallback?: string
  }>(),
  { size: 48 }
)

const webpPath = computed(() => `/icons/platforms/${props.platform}.webp`)
const label = computed(() => props.fallback || props.platform)
</script>

<template>
  <div
    class="platform-icon"
    :class="`platform-icon--${platform}`"
    :style="{ width: `${size}px`, height: `${size}px` }"
  >
    <img
      :src="webpPath"
      :alt="platform"
      :width="size"
      :height="size"
      class="platform-icon__img"
    />
  </div>
</template>

<style scoped>
.platform-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.platform-icon__img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>